/**
 * Whether the `registration.enabled` system setting opens sign-up, read as SPT reads it
 * (DWLF-585): open only when it says true (boolean true, the string 'true' in any case, or
 * `{ enabled: true }`); missing or anything else is closed.
 */
export function isRegistrationOpen(value) {
  if (value === true) return true;
  if (typeof value === 'string') return value.toLowerCase() === 'true';
  return value?.enabled === true;
}
